import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  OnDestroy,
  output,
  OutputEmitterRef,
  ViewEncapsulation
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import {
  AppRoutes,
  CacheKey,
  GamesRoutes,
  HostedGamesRoutes,
  NAVIGATION_TOKEN,
  NavigationProvider,
  TeamsRoutes
} from '@core';
import { Router } from '@angular/router';
import { ChannelDetailsQueryResult } from '../../application/handlers';
import { ChatChannelType } from '@core-http';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-chat-navbar',
  templateUrl: './chat-navbar.component.html',
  styleUrls: ['./chat-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [IonicModule, OrIconComponent]
})
export class ChatNavbarComponent implements OnDestroy {
  private readonly navigationProvider: NavigationProvider = inject(NAVIGATION_TOKEN);
  private readonly router: Router = inject(Router);

  readonly date: InputSignal<string | undefined> = input<string | undefined>();
  readonly details: InputSignal<ChannelDetailsQueryResult | undefined> = input<ChannelDetailsQueryResult | undefined>();
  readonly hideActions: InputSignal<boolean> = input<boolean>(false);

  readonly actionOnBack: OutputEmitterRef<void> = output<void>();
  readonly onDotsClicked: OutputEmitterRef<void> = output<void>();

  ngOnDestroy(): void {
    sessionStorage.removeItem(CacheKey.RedirectToGameFromChatUrl);
  }

  goBack(): void {
    const redirectToGameUrl: string | null = sessionStorage.getItem(CacheKey.RedirectToGameFromChatUrl);

    if (!!redirectToGameUrl) {
      sessionStorage.removeItem(CacheKey.RedirectToGameFromChatUrl);
      this.router.navigate([redirectToGameUrl]);
      this.actionOnBack.emit();
      return;
    }

    this.navigationProvider.back();
    this.actionOnBack.emit();
  }

  dotsClicked(): void {
    this.onDotsClicked.emit();
  }

  redirect(): void {
    const details: ChannelDetailsQueryResult | undefined = this.details();

    if (!details) return;

    if (details.channelType === ChatChannelType.team && details.teamId) {
      this.router.navigateByUrl(`${AppRoutes.TEAMS}/${details.teamId}/${TeamsRoutes.TEAM_DETAILS}`);
    }

    if (details.channelType === ChatChannelType.multi && details.closestGame?.gameId) {
      const hostUrl: string = `${AppRoutes.HOST}/${HostedGamesRoutes.FUTURE}/${details.closestGame?.gameId}`;
      const playerUrl: string = `${AppRoutes.GAMES}/${GamesRoutes.DETAILS}/${details.closestGame?.gameId}`;
      const url: string = details.closestGame?.isHost ? hostUrl : playerUrl;

      this.router.navigateByUrl(url);
    }

    if (details.channelType === ChatChannelType.single && details.secondUserId) {
      const url: string = `${AppRoutes.PROFILE}/${details.secondUserId}`;

      this.router.navigateByUrl(url);
    }
  }
}
